import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import {
    Input,
    TextArea,
    Form,
    Switch as Toggle,
    Button,
    IconButton,
    Select
} from '@gpstrackit/gtc-react-controls';


const Checkbox = (props) => {
    const { messages } = useIntl();

    const {
        question,
        handleClose,
        updateQuestion
    } = props;

    const questionForm = Form.useForm();
    const [options, setOptions] = useState([{ id: "option1", value: "" }]);
    const [formData, setFormData] = useState({});

    const open = useSelector(state => state.dynamicFormsDesignRedux.openQuestionConfiguration);
    const loading = useSelector(state => state.dynamicFormsDesignRedux.loading);

    useEffect(() => {
        if (open && questionForm?.ref && question) {
            let newValues = { ...question };
            let newOptions = [...options];

            if (question?.attributes?.options?.length) {
                newOptions = [];
                let defaultValue = question?.attributes?.default;
                question?.attributes?.options?.forEach((opt, key) => {
                    let optNum = key + 1;
                    newValues[`option${optNum}`] = opt;
                    newOptions.push({ id: `option${optNum}`, value: opt });
                    defaultValue = defaultValue === opt ? { id: `option${optNum}`, value: defaultValue } : defaultValue
                });
                newValues['default'] = defaultValue;
            }

            questionForm?.setValues(newValues);
            setFormData(newValues)
            setOptions(newOptions);
        }
    }, [questionForm?.ref, open, question]);

    return (
        <div>
            <Form
                ref={questionForm?.ref}
                loading={loading}
                onValidSubmit={(values) => {
                    let newOptions = [];
                    options?.forEach((opt) => {
                        if (!newOptions.includes(values[opt.id])) {
                            newOptions.push(values[opt.id]);
                        }
                    });

                    let newQuestion = {
                        ...question,
                        label: values?.label,
                        placeHolder: values?.placeHolder,
                        help: values?.help,
                        required: values?.required,
                        readOnly: values?.readOnly,
                        attributes: {
                            default: values?.default?.value || null,
                            options: newOptions
                        }
                    };

                    updateQuestion(newQuestion);
                }}
                onChangeValues={(newValues) => {
                    setFormData(newValues)
                }}
            >
                <div>
                    <Form.Item
                        name="label"
                        label={messages['dynamicFormsDesign_label']}
                        rules={[{ required: true, message: 'required_field' }]}
                    >
                        <Input
                            id="label"
                            type="text"
                            placeholder={messages['dynamicFormsDesign_label']}
                            maxLength={100}
                        />
                    </Form.Item>

                    <Form.Item
                        name="help"
                        label={messages['dynamicFormsDesign_helpText']}
                    >
                        <TextArea
                            id="help"
                            placeholder={messages['dynamicFormsDesign_helpText']}
                            maxLength={1000}
                        />
                    </Form.Item>

                    <Form.Item
                        name="required"
                        label={messages['dynamicFormsDesign_required']}
                    >
                        <Toggle
                            id="required"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        readOnly: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="readOnly"
                        label={messages['dynamicFormsDesign_readOnly']}
                    >
                        <Toggle
                            id="readOnly"
                            optionLabels={[
                                messages['dynamicFormsDesign_yes'],
                                messages['dynamicFormsDesign_no']
                            ]}
                            onChange={(value) => {
                                let timer = setTimeout(() => {
                                    const newFormData = {
                                        ...formData,
                                        required: false
                                    };

                                    setFormData(newFormData);
                                    questionForm?.setValues(newFormData);
                                    timer = null;
                                }, 50);
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="default"
                        label={messages['dynamicFormsDesign_defaultValue']}
                    >
                        <Select
                            id="default"
                            options={options.map((opt, key) => {
                                return { ...opt, value: opt?.value || `Option ${key + 1}` };
                            })}
                            isMulti={false}
                            isClearable={true}
                            isSearchable={true}
                            placeholder={messages['dynamicFormsDesign_defaultValue']}
                            textField={"value"}
                            valueField={"value"}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <div style={{ marginBottom: 15 }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >

                            <Grid item xs>
                                <h3 style={{ margin: 0 }}>Options list</h3>
                            </Grid>
                            <Grid>
                                <IconButton
                                    onClick={(e) => {
                                        if (e) {
                                            e.preventDefault();
                                        }

                                        if (options?.length < 11) {
                                            let newOptions = [...options];
                                            let option = `option${options?.length + 1}`;
                                            newOptions.push({ id: option, value: "" });
                                            setOptions(newOptions);
                                        }
                                    }}
                                    icon='add_circle'
                                    size='medium'
                                    tooltip={messages['dynamicFormsDesign_addOption']}
                                    placement="left-end"
                                    variant='primary'
                                    isDisabled={(options?.length >= 10) ? true : false}
                                />
                            </Grid>
                        </Grid>

                        <hr />
                    </div>

                    {
                        options?.map((option, key) => {
                            return (
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    key={key}
                                >
                                    <Grid item xs>
                                        <Form.Item
                                            name={option?.id}
                                            label={`Option ${key + 1}`}
                                            rules={[
                                                { required: true, message: 'required_field' },
                                                (currentValues, newValue) => {
                                                    let newCurrentValues = { ...currentValues };
                                                    if (newCurrentValues[option.id]) {
                                                        delete newCurrentValues[option.id];
                                                    }
                                                    let currentOptions = [];
                                                    options?.forEach(opt => {
                                                        if (newCurrentValues[opt?.id]) {
                                                            currentOptions.push(opt.value);
                                                        }
                                                    });

                                                    if (currentOptions?.includes(newValue)) {
                                                        return messages['dynamicFormsDesign_duplicateValue'];
                                                    }

                                                    return null;
                                                }
                                            ]}
                                            key={key}
                                        >
                                            <Input
                                                id="onLabel"
                                                type="text"
                                                placeholder={`${messages['dynamicFormsDesign_option']} ${key + 1}`}
                                                maxLength={100}
                                                onChange={(value) => {
                                                    let newOptions = options?.map(op => {
                                                        if (op?.id === option?.id) {
                                                            return { id: op?.id, value: value }
                                                        }

                                                        return op;
                                                    });

                                                    setOptions(newOptions);
                                                }}
                                            />
                                        </Form.Item>
                                    </Grid>

                                    <Grid>
                                        {
                                            key > 0 &&
                                            <IconButton
                                                onClick={(e) => {
                                                    if (e) {
                                                        e.preventDefault();
                                                    }

                                                    let newFormData = { ...formData };

                                                    if (option?.id === formData?.default?.id) {
                                                        newFormData = { ...formData, default: null };
                                                    }

                                                    let newOptions = options?.filter(o => o.id != option?.id);

                                                    if (newFormData?.hasOwnProperty(`${option?.id}`)) {
                                                        delete newFormData[option?.id];
                                                    }

                                                    setOptions(newOptions);
                                                    questionForm?.resetValues();

                                                    let timer = setTimeout(() => {
                                                        setFormData(newFormData);
                                                        questionForm?.setValues(newFormData);
                                                        timer = null;
                                                    }, 50);
                                                }}
                                                size='small'
                                                icon='remove_circle'
                                                tooltip={messages['dynamicFormsDesign_removeOption']}
                                                variant="warning"
                                                placement="left-end"
                                                style={{
                                                    marginLeft: 5
                                                }}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </div>
            </Form>

            <div style={{ display: 'flex', justifyContent: 'end', marginTop: 15 }}>
                <Button
                    style={{ marginRight: 8 }}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.resetValues()
                        handleClose();
                    }}
                    variant='secondary'
                >
                    {messages['cancel']}
                </Button>

                <Button
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        questionForm?.submit();
                    }}
                    variant='primary'
                >
                    {messages['save']}
                </Button>
            </div>
        </div>
    );
}

export default Checkbox;